module.exports = __webpack_public_path__ + "gb-wls.25cf5fa496965254d339.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/vendors/flag-icon/flags/4x3/gb-wls.svg
// module id = ../../../../../src/assets/vendors/flag-icon/flags/4x3/gb-wls.svg
// module chunks = 0